import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const MailIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M13.333 3.167H2.667c-.734 0-1.327.6-1.327 1.333l-.007 8c0 .733.6 1.333 1.334 1.333h10.666c.734 0 1.334-.6 1.334-1.333v-8c0-.733-.6-1.333-1.334-1.333Zm0 9.333H2.667V5.833L8 9.167l5.333-3.334V12.5ZM8 7.833 2.667 4.5h10.666L8 7.833Z" />
  </Icon>
);

export default memo(MailIcon);
